// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Lulu Rewards green. Kept here as a literal because Vuetify's theme
// API does not read CSS custom properties - the design-token source of
// truth still lives in App.vue (`--lulu-primary`) and this value must
// stay in sync with it.
const LULU_PRIMARY = 'rgb(0, 109, 62)'

export default createVuetify({
  theme: {
    defaultTheme: 'luluLight',
    themes: {
      luluLight: {
        dark: false,
        colors: {
          primary: LULU_PRIMARY,
        },
      },
    },
  },
})
